module.exports = flarum.core.compat['components/NotificationsDropdown'];